import React, { FC } from 'react';
import { Breakpoint, Typography } from '@altibox/design-system-component-lib';

import { i18n } from 'app/i18n';
import { mapPinImageProps } from 'app/resources/images';

import { SuccessInformation, SuccessInformationProps } from './success-information/success-information';

interface OwnProps {
    isHomeGatewayUpgradeNeeded: boolean;
}

type Props = OwnProps & Pick<SuccessInformationProps, 'loading'>;

export const DeliveryInformation: FC<Props> = (props) => {
    const { isHomeGatewayUpgradeNeeded, ...rest } = props;

    const deliveryInformation = isHomeGatewayUpgradeNeeded
        ? {
              title: i18n.page.success.delivery.technician.title,
              description: i18n.page.success.delivery.technician.description,
          }
        : {
              title: i18n.page.success.delivery.transporter.title,
              description: i18n.page.success.delivery.transporter.description,
          };

    return (
        <SuccessInformation
            {...rest}
            icon={mapPinImageProps}
            title={deliveryInformation.title}
            description={
                <Typography variant="paragraph2" component="p" maxBreakpoint={Breakpoint.TABLET}>
                    {deliveryInformation.description}
                </Typography>
            }
        />
    );
};
